// extracted by css-extract-rspack-plugin
export default {"SidebarView":"wyDnZ"};